<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> ده کالای برتر
      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="recursive-good-chart"></chart-export-btn>

    </v-card-title>
    <v-card-subtitle class="info--text">بر مبنای برگشت از فروش</v-card-subtitle>
    <canvas  height="100" id="recursive-good-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'RecursiveGoodChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "bar",
        data: {
          labels: ["کالا یک", "کالا دو", "کالا سه", "کالا چهار", "کالا پنج","کالا یک", "کالا دو", "کالا سه", "کالا چهار", "کالا پنج"],
          datasets: [
            {
              label: "برگشت از فروش",
              data: [180000, 110000,240000, 100000, 250000,180000, 110000,240000, 100000, 250000],
              backgroundColor: "#019EF6",
              borderColor: "#019EF6",
              borderWidth: 3,
              hoverBorderWidth:5
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          tooltips: {
            enabled: true,
            mode: 'index',
            position: 'average',
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                if(parseInt(tooltipItem.yLabel) >= 1000){
                  label += tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                } else {
                  label += tooltipItem.yLabel + ' ريال ';
                }
                return label
              },
            },
          },

          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .08)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15,
                  callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ريال ';
                    } else {
                      return value + ' ريال ';
                    }
                  }

                }
              }
            ]
          }
        }
      },
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/BackFromBuySaleSumByWare?type=${this.report_type}`),
        method: "get",
        success: data => {
          this.setData(data.results)
        }
      })
    },

    setData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []

      for (let ware of data){
        this.chartData.data.labels.push(ware.title)
        this.chartData.data.datasets[0].data.push(ware.amount)

      }

      this.setChart()
    },
    setChart(){
      const ctx = document.getElementById('recursive-good-chart');
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  }
}
</script>